<template>
  <div class="page">
    <div class="weui-msg">
      <div class="weui-msg__icon-area">
        <div class="scan-bnt" @click="scan">
          <i class="iconfont icon-saomiaoshibie380 weui-icon_msg"></i>
        </div>
      </div>
    </div>
    <div class="page__bd">
      <div class="weui-cells__title">各快递寄件待出库统计</div>
      <div class="weui-cells">
        <div class="weui-cell" v-for="item in list" :key="item._id">
          <div class="weui-cell__bd">
            <p>{{item.name}}</p>
          </div>
          <div class="weui-cell__ft">{{item.count}} 件</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../config/config.js";
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");
import io from "socket.io-client";

export default {
  data() {
    return {
      worksiteId: "",
      list: []
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["scanQRCode"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    // 建立 socket 连接
    const socket = io(config.socket, {
      transports: ["websocket"]
    });
    // 建立 socket 连接
    socket.on("connect", function() {
      console.log("socket.io connect...");
    });
    socket.on("reconnect_attempt", () => {
      socket.io.opts.transports = ["websocket", "polling"];
    });

    let that = this;
    axios
      .get("/api/user/wxuserInfo")
      .then(res => {
        if (res.data.success) {
          this.worksiteId = res.data.data.worksite._id;
          let expressSendCompanies =
            res.data.data.worksite.expressSendCompanies;
          for (let i = 0; i < expressSendCompanies.length; i++) {
            let expressCompanyId = expressSendCompanies[i];

            let socketKey =
              that.worksiteId + "-" + expressCompanyId + "-toScan";
            // 监听socket消息
            socket.on(socketKey, function(num) {
              weui.alert(num);
              for (let j = 0; j < that.list.length; j++) {
                if (that.list[j]._id == expressCompanyId) {
                  if (num < 0) {
                    if (that.list[j].count > 0) {
                      that.list[j].count += num;
                      weui.alert(that.list[j].count);
                    }
                  } else {
                    that.list[j].count += num;
                  }
                  break;
                }
              }
            });

            axios
              .get(
                "/api/expressTakein/toScan/" +
                  that.worksiteId +
                  "/" +
                  expressCompanyId
              )
              .then(countRes => {
                if (countRes.data.success) {
                  that.list.push(countRes.data.data);
                } else {
                  weui.alert("获取待寄件统计出错");
                }
              })
              .catch(countErr => {
                console.log(countErr);
                weui.alert("获取待寄件统计出错");
              });
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    scan() {
      let that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let expressNo = "";
          let scanResult = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (scanResult.indexOf(",") >= 0) {
            // 扫描一维码的时候会返回一维码的编码规则
            expressNo = scanResult.substring(scanResult.indexOf(",") + 1);
          } else {
            expressNo = scanResult;
          }

          axios
            .put(
              "/api/expressTakein/sendOut/" + that.worksiteId + "/" + expressNo
            )
            .then(sendRes => {
              if (sendRes.data.success) {
                weui.toast("出库成功", 2000);
              } else {
                weui.alert(sendRes.data.message);
              }
            })
            .catch(sendErr => {
              console.log(sendErr);
              weui.alert("寄件出库失败");
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.scan-bnt {
  width: 92px;
  height: 92px;
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  color: #1aad19;
  text-align: center;
  line-height: 92px;
  border-radius: 46px;
  font-size: 22px;
  box-shadow: 0px 0px 20px #1aad19;
  background-color: #fff;
}
.weui-icon_msg {
  font-size: 50px;
}
.weui-msg {
  padding-top: 50px;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/ToTakeinOutScan.vue